export default "__VITE_ASSET__NRB_kEpI__"